import Head from "next/head";
import Link from "next/link";

function ExtLink({ href }) {
	return (
		<div className="mt-6">
			<a className="break-all" target="_blank" rel="noreferrer" href={href}>
				{href}
			</a>
		</div>
	);
}

const links = [
	"https://en.wikipedia.org/wiki/File:Au_Clair_de_la_Lune_(1860).ogg",
	"https://en.wikipedia.org/wiki/Black_Mountain_College",
	"https://www.tribes.org/",
	"https://www.dailymotion.com/video/xl61of",
	"https://www.youtube.com/watch?v=7Vh2976yvp0",
	"https://www.youtube.com/watch?v=uzk27ZH53Fs",
	"https://en.wikipedia.org/wiki/Blue_box",
	"https://www.mcmaster.com/",
	"https://en.m.wikipedia.org/wiki/Siphonophorae",
	"https://www.youtube.com/watch?v=CWRTqMGvdpc",
];

export default function Important() {
	return (
		<>
			<Head>
				<title key="title">Important | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center">Belshazzar&rsquo;s Feast</h1>
				<div className="text-lg leading-7 mt-5">
					{links.map((link, index) => {
						return <ExtLink key={`link_${index}`} href={link} />;
					})}
				</div>
				<div className="mt-6">
					<a href="https://google.com" className="mt-14" rel="noreferrer" target="_blank">
						Not satisfied? Click here.
					</a>
				</div>
			</div>
		</>
	);
}
